export const T = {
  en_GB: {
    delete: "Delete",
    goalsNeedAttention: (count: string) => `${count} goal(s) need attention`,
  },
  nb_NO: {
    delete: "Slett",
    goalsNeedAttention: (count: string) => `${count} mål trenger oppmerksomhet`,
  },
} as const;
